import './App.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// Components
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Home from './components/Pages/Home';
import Contact from './components/Pages/Contact';
import Hi from './components/Pages/Hi';
import HiRender from './components/Pages/HiRender';
import HiRenderDemo from './components/Pages/HiRenderDemo'
import HiLite from './components/Pages/HiLite';
import Blogs from './components/Pages/Blogs';
import TermsConditions from './components/Footer/TermsConditions';
import PrivacyPolicy from './components/Footer/PrivacyPolicy';
import Admin from './components/Pages/Admin';
import Payment from './components/Pages/Payment';
import paymentResult from './components/Pages/PaymentResult';
import SplashScreen from './components/SplashScreen/SplashScreen';
import Services from './components/Pages/Services';
import DL_Course from './components/Pages/DL_Course';

import { 
  authListener,
  getBillNumber 
} from "./Redux/actions";

import { 
  handle_SplashScreen
} from "./Redux/reducer";


const App = () => {
  
  const dispatch = useDispatch();
  // const [isSplashScreen,setIsSplashScreen] = useState(true);
  const isSplashScreen = useSelector((state) => state.auth.isSplashScreen);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const invoice = useSelector((state) => state.auth.invoice);
  const activePage = useSelector((state) => state.auth.activePage);
  
  useEffect(
      () => {
        dispatch(authListener());
      },
      [isAuthenticated],
    );

  useEffect(
      () => {
        if(activePage == "paymentResult?data=success" || activePage == "?data=success") {
          // console.log("lohith:Navbar:useEffect: inside if 1");
          dispatch(getBillNumber("receipt"));
          // if(invoice.items.length > 0){
          //     console.log("lohith:Navbar:useEffect: inside if 2");
          //     dispatch(getBillNumber("receipt"));
          // } else {
          //     console.log("lohith:Navbar:useEffect: inside else 2");
          //     window.location.replace("https://www.airender.co.in/");
          // }
      }
      },
      [],
    );
  
  setTimeout(() => {
    // setIsSplashScreen(false);
    if (isSplashScreen == true){
      dispatch(handle_SplashScreen(false));
    }
  }, 3000);
  
  return (
    isSplashScreen
    ?<SplashScreen />
    :<Router>
      <Navbar />
      <div className='website-component'>
        <Switch>
          <Route path="/" component={Home} exact />
          <Route path="/hi" component={Hi} exact />
          <Route path="/hiLite" component={HiLite} exact />
          <Route path="/hiRender" component={HiRender} exact />
          <Route path="/hiRender/demo" component={HiRenderDemo} exact />
          <Route path="/blogs" component={Blogs} exact />
          <Route path="/TermsConditions" component={TermsConditions} exact />
          <Route path="/PrivacyPolicy" component={PrivacyPolicy} exact />
          <Route path="/admin" component={Admin} exact />
          <Route path="/contact" component={Contact} exact />
          <Route path="/payment" component={Payment} exact />
          <Route path="/paymentResult" component={paymentResult} exact />
          <Route path="/services" component={Services} exact />
          <Route path="/DL_Course" component={DL_Course} exact />
        </Switch>
      </div>
      <Footer />
    </Router>
  );
}

export default App;